module.exports = __webpack_public_path__ + "img/lock-active.7630433e.svg";